export const OutreachType = {
  MANUAL_TARGETED: 'manual_targeted',
  BROADCAST_TARGETED: 'broadcast_targeted',
};

// Initial-filter seed key for the broadcast modal's single "Disengaged clients" recipient option.
export const DISENGAGEMENT_BROADCAST_TAG = 'ALL_DISENGAGED';

export const DisengagementCriteria = {
  MISSED_CHECK_IN: 'MISSED_CHECK_IN',
  MISSED_WORKOUT: 'MISSED_WORKOUT',
  CHAT_SILENCE: 'CHAT_SILENCE',
};

export const DisengagementCriteriaValues = Object.values(DisengagementCriteria);

export const DisengagementCriteriaLabel = {
  [DisengagementCriteria.MISSED_CHECK_IN]: 'Missed Check-in (14+ days)',
  [DisengagementCriteria.MISSED_WORKOUT]: 'No Workout (6+ days)',
  [DisengagementCriteria.CHAT_SILENCE]: 'Chat Silent (3+ weekdays)',
};

export const CHAT_SILENCE_INDICATOR_LABEL = 'Chat silent';
